import React, {MouseEvent, useEffect, useMemo, useState} from 'react';
import styles from './unitList.module.scss';
import RightIcon from 'src/assets/icons/chewron_right.svg?react';

import UnitContentsSidebarList from './UnitContentsSidebarList';
import { Unit } from '@types';

type Props = {
  title: string;
  units: Unit[] | undefined;
  unitOpened: boolean;
  courseId?: string;
  isPrimary?: boolean;
};

function PrimaryUnits(props: Props) {
  const { title, units = [], unitOpened, courseId, isPrimary } = props;

  const [opened, setOpened] = useState(true);

  useEffect(() => {
    if (unitOpened) setOpened(true);
  }, [unitOpened])

  const handleToggle = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    const _opened = !opened;
    setOpened(_opened);
  };

  const wrapperClassName = useMemo(() => {
    const classes = [styles.wrapper];
    if (opened) {
      classes.push(styles.opened);
    }

    return classes.join(' ');
  }, [opened]);

  return (
    <div className={wrapperClassName}>
      <div onClick={handleToggle} className={styles.header}>
        <RightIcon className={styles.rightIcon}/>
        <div className={styles.title}>{title}</div>
      </div>
      <div className={styles.content}>
      {courseId && <UnitContentsSidebarList units={units} droppableId={title} courseId={courseId} isPrimary={isPrimary} />}
      </div>
    </div>
  );
}

export default React.memo(PrimaryUnits);
